// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"aa82ba57","117":"e2d2dabe","148":"8d5b796e","204":"435c5236","328":"1086b1c8","364":"9b83ddfd","415":"de8246f4","468":"ad64917b","581":"b27be6ff","787":"4d4ea225","874":"60321fb6","910":"d427a007","960":"66b24cfa"}[chunkId] + ".chunk.js";
};